import { TakeDurationBox } from "components/TakeDurationBox/TakeDurationBox"
import { TakeNoteBox } from "components/TakeNoteBox/TakeNoteBox"

import { TestData } from "graphql/types"

type WaitingTimeProps = {
  data: TestData
  setData: (data: TestData) => void
}

export const WaitingTime = (props: WaitingTimeProps) => {
  const { data, setData } = props

  return (
    <>
      <TakeNoteBox data={data} setData={setData} name="Wartezeit " />
      <TakeDurationBox data={data} setData={setData} />
    </>
  )
}
